import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'unh-old-price-tag',
  templateUrl: './old-price-tag.component.html',
  styleUrls: ['./old-price-tag.component.scss']
})
export class OldPriceTagComponent implements OnInit, AfterViewInit {
  @Input() value;
  @Input() textColor;
  @Input() lineColor;
  
  @ViewChild('price', { static: false } ) price: ElementRef;
  constructor(
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
   
  }
  ngAfterViewInit() {
    if (this.textColor) {
      this.renderer.setStyle(this.price.nativeElement, 'color', this.textColor);
      
    }
  }
}
